var map = {
	"./404.svg": 941,
	"./Categories.png": 942,
	"./Edit-menu.svg": 943,
	"./Egg.svg": 944,
	"./Emaier-Header.png": 945,
	"./Qr-4.png": 946,
	"./_duplicate.svg": 947,
	"./_overview.svg": 948,
	"./add-white.svg": 949,
	"./alert.svg": 950,
	"./all_category.svg": 951,
	"./archive.svg": 952,
	"./armchair.svg": 953,
	"./arrow-circle-right.svg": 954,
	"./arrow-left-circle.svg": 955,
	"./arrow-right-circle.svg": 956,
	"./arrow-right.svg": 355,
	"./asc-up-white.svg": 957,
	"./asc.png": 958,
	"./asc.svg": 959,
	"./back-arrow.svg": 960,
	"./barcode-icon.svg": 961,
	"./beverages.svg": 962,
	"./blue-edit-pen.svg": 963,
	"./blue-eye.svg": 964,
	"./box-office.svg": 965,
	"./broken-seat.jpg": 966,
	"./calendar_list.svg": 967,
	"./chevron-down.svg": 968,
	"./chevron-left.svg": 969,
	"./cinema-mamagement-sidebar.svg": 970,
	"./claendar.svg": 305,
	"./clock-1.svg": 971,
	"./clock.svg": 972,
	"./close-button.svg": 702,
	"./close-white.svg": 704,
	"./close-x.svg": 300,
	"./collapse-up.svg": 973,
	"./collapse.svg": 974,
	"./connection-lost.svg": 353,
	"./copy.svg": 975,
	"./copy_image_icon.png": 976,
	"./delete-red-light.svg": 977,
	"./delete-red.svg": 710,
	"./delete.svg": 687,
	"./deliver-icon.svg": 978,
	"./desc-down-white.svg": 979,
	"./desc.svg": 980,
	"./distributors-sidebar.svg": 981,
	"./download.svg": 982,
	"./dragndrop.svg": 983,
	"./dragndrop2.svg": 984,
	"./duplicate.svg": 985,
	"./duplicateScreen.svg": 986,
	"./e-wallet-icon-black.svg": 987,
	"./edit-pen-blue.svg": 988,
	"./edit-pen-white.svg": 989,
	"./edit-pen.svg": 990,
	"./edit.svg": 991,
	"./email.png": 992,
	"./empty-image.svg": 993,
	"./excel.svg": 994,
	"./external-link.svg": 995,
	"./eye.svg": 996,
	"./filter-icon.svg": 997,
	"./flag.svg": 998,
	"./fnb-app-order.svg": 999,
	"./fnb-beverages.svg": 1000,
	"./fnb-brownie.svg": 1001,
	"./fnb-combo.svg": 1002,
	"./fnb-desert.svg": 1003,
	"./fnb-eatables.svg": 1004,
	"./fnb-make-your-combo.svg": 1005,
	"./fnb-popcorn.svg": 1006,
	"./fnbtransactionIcon.svg": 1007,
	"./fullscreen-icon.svg": 711,
	"./funnel.svg": 1008,
	"./globe.svg": 1009,
	"./green-tick.svg": 1010,
	"./grid-view.svg": 1011,
	"./hide-password.svg": 356,
	"./home-icon.svg": 1012,
	"./home.svg": 1013,
	"./icon-black-play.svg": 1014,
	"./icon-dot.svg": 1015,
	"./icon-fnb.svg": 1016,
	"./icon-marketing.svg": 1017,
	"./icon-no-seat.png": 1018,
	"./icon-no-seat.svg": 1019,
	"./icon-option.svg": 1020,
	"./icon-poin-of-sale.svg": 1021,
	"./icon-recliner.svg": 1022,
	"./icon-report.svg": 1023,
	"./icon-sofa-dark-1.svg": 1024,
	"./icon-sofa-dark.png": 1025,
	"./icon-sofa-dark.svg": 1026,
	"./icon-sofa.svg": 1027,
	"./importfile.svg": 1028,
	"./info.svg": 705,
	"./info2.svg": 1029,
	"./keyboard-icon.svg": 1030,
	"./kitchen_display.svg": 1031,
	"./language-icon.svg": 301,
	"./left-caret.svg": 1032,
	"./link.svg": 1033,
	"./list-view.svg": 1034,
	"./loading.svg": 357,
	"./lock.svg": 1035,
	"./login-password.png": 358,
	"./login-user.png": 359,
	"./logout.svg": 706,
	"./masters-sidebar.svg": 1036,
	"./merchandise.svg": 1037,
	"./minus.svg": 1038,
	"./movie-pass-svg.svg": 693,
	"./movie-rolling.svg": 1039,
	"./mulitSchedule.svg": 1040,
	"./multicurrency.svg": 1041,
	"./multifnb.svg": 1042,
	"./nav-plus.svg": 1043,
	"./new_filter_icon.svg": 1044,
	"./no-image.svg": 1045,
	"./no-schedule.svg": 134,
	"./non-veg-mark.png": 1046,
	"./non-veg-mark.svg": 1047,
	"./notification.svg": 1048,
	"./open-link-blue.svg": 1049,
	"./openPlanned.svg": 1050,
	"./overview.svg": 1051,
	"./overview2.svg": 1052,
	"./pdf-icon.svg": 1053,
	"./pdf.svg": 1054,
	"./pickup-ticket-icon.svg": 1055,
	"./pickupfnb.svg": 1056,
	"./play.svg": 1057,
	"./plus.svg": 1058,
	"./pointofsale-1.svg": 1059,
	"./pointofsale-2.svg": 1060,
	"./pointofsale.png": 1061,
	"./portfolio.svg": 1062,
	"./pos-fnb-no-itmes.svg": 699,
	"./pos-refresh.svg": 1063,
	"./primary/chevron-down.svg": 1064,
	"./primary/download.svg": 1065,
	"./primary/edit.svg": 1066,
	"./primary/filter.svg": 1067,
	"./primary/printer.svg": 1068,
	"./print-icon.svg": 1069,
	"./print.svg": 1070,
	"./question.svg": 1071,
	"./question1.svg": 1072,
	"./question2.svg": 712,
	"./question3.svg": 1073,
	"./recliner-1.svg": 1074,
	"./recliner.png": 1075,
	"./refund-icon.svg": 1076,
	"./reload-icon-pos.svg": 1077,
	"./reload-icon.svg": 1078,
	"./restore.svg": 1079,
	"./right-caret.svg": 1080,
	"./role-management-sidebar.svg": 1081,
	"./save.svg": 1082,
	"./schedule-icon.svg": 1083,
	"./school-calendar.svg": 1084,
	"./search-global-white.svg": 1085,
	"./search-global.svg": 1086,
	"./search.svg": 713,
	"./searchIcon.svg": 1087,
	"./seat-icon-2.svg": 1088,
	"./seat-icon.svg": 1089,
	"./seat-icons/3-wheelChair.png": 1090,
	"./seat-icons/block_seat_new.png": 1091,
	"./seat-icons/broken-seat-1.svg": 1092,
	"./seat-icons/broken-seat-2.svg": 1093,
	"./select-food.png": 714,
	"./settings.svg": 1094,
	"./show-password.svg": 360,
	"./slider-triangle.svg": 1095,
	"./snack.svg": 707,
	"./sort.svg": 1096,
	"./star-empty.svg": 1097,
	"./star-fill.svg": 1098,
	"./success-tick.svg": 1099,
	"./suitcase.svg": 1100,
	"./swap.svg": 1101,
	"./tick-green-item.svg": 715,
	"./tick-green.svg": 1102,
	"./ticket-icon.svg": 1103,
	"./trash.svg": 1104,
	"./unpaid-reservation.svg": 689,
	"./updown-white.svg": 1105,
	"./updown.svg": 1106,
	"./user-attribute.svg": 1107,
	"./user-attributes.svg": 1108,
	"./user-female.svg": 1109,
	"./user-male-white.svg": 1110,
	"./user-male.svg": 1111,
	"./user-profile.svg": 1112,
	"./userProfile.png": 1113,
	"./veg-food-mark-white.png": 1114,
	"./veg-foog-mark-trans.png": 1115,
	"./view.png": 1116,
	"./view.svg": 1117
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 940
// module chunks = 33